/**
 * Alias Symfony camelCase event fields (`pilotId`, `instructorId`,
 * `resourceIds[]`) to the legacy `pilotID` / `instructorID` / `resourceID`
 * shape that filters, selectors and permission checks read. Without this
 * aliasing, `filters.pilot` / `filters.instructor` / `filters.resource`
 * all read `undefined` from the event and filter everything out → empty
 * calendar.
 *
 * Location has no id field in `BaseEventsResponseDto` — `locationID` is
 * resolved later in the thunk via the resources ref map.
 *
 * @module normalizeEvent
 */
export function normalizeEvent(ev) {
	if (!ev || typeof ev !== 'object') return ev;
	const resourceID =
		ev.resourceID != null
			? ev.resourceID
			: Array.isArray(ev.resourceIds)
				? ev.resourceIds[0] ?? null
				: ev.resourceIds ?? null;
	return {
		...ev,
		pilotID: ev.pilotID ?? ev.pilotId ?? null,
		instructorID: ev.instructorID ?? ev.instructorId ?? null,
		resourceID,
		// `BaseEventsResponseDto` doesn't currently expose `locationId` — only
		// `locationName`/`locationCity`/`locationTimezoneId`. The alias is in
		// place so if backend adds `locationId` later, the filter code
		// (`event.locationID`) starts working without any further change.
		locationID: ev.locationID ?? ev.locationId ?? null
	};
}
